export default __webpack_public_path__ + "static/media/RobotoCondensed-Light.8085ddb7.ttf";